import { useRef } from 'react'

import { useSize } from 'ahooks'
import { FloatButton } from 'antd'
import { createStyles } from 'antd-style'

import { RouterOutlet } from '@eastcoal/router/components/Outlet'

import { LayoutContainer } from '../components/Container'
import { LayoutFooter } from '../components/Footer'
import { LayoutHeader } from '../components/Header'

import { MallLayoutContext } from './context'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    minWidth: token.layoutContentWidth,
    backgroundColor: token.colorBgLayout
  },
  body: {
    paddingBlockStart: 1,
    paddingBlockEnd: token.paddingMD,
    ['.page-container-breadcrumb']: {
      paddingBlock: token.paddingXXS
    }
  }
}))

export const MallLayout = () => {
  const ref = useRef<HTMLDivElement>(null)
  const bodySize = useSize(document.body)
  const { styles } = useStyles()

  return (
    <MallLayoutContext value={{ containerRef: ref }}>
      <div ref={ref} className={styles.container}>
        <LayoutHeader />
        <LayoutContainer className={styles.body}>
          <RouterOutlet />
        </LayoutContainer>
        <LayoutFooter />
        <FloatButton.BackTop
          tooltip='返回顶部'
          visibilityHeight={bodySize?.height}
        />
      </div>
    </MallLayoutContext>
  )
}
